import { use } from "react";
import { useLoaderData as useLoaderDataBase } from "react-router-dom";
import {
  App,
  routes as allRoutes,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import { Api } from "../../shared/utils/api.utils";

// TEXT

// STYLES

// DATA
export const signOut = async () => {
  const result = await Api.request({
    method: "POST",
    url: fullEndpoints[App.Core].auth.signOut,
  });

  const { redirectUrl, adminSignOutUrl } = result.data.data;

  // If an admin session was detected, redirect through admin sign-out
  // which clears admin cookies and then redirects to the Cognito sign-out
  if (adminSignOutUrl) {
    const url = new URL(adminSignOutUrl);
    url.searchParams.set("redirectTo", redirectUrl);
    return url.toString();
  }

  return redirectUrl;
};

// TYPES
export type LoaderData = {
  signOut: ReturnType<typeof signOut>;
};

// CONSTANTS
export const routes = allRoutes[App.Core];

// FUNCTIONS
export const useLoaderData = () => {
  const { signOut } = useLoaderDataBase<LoaderData>();
  return { signOut: use(signOut) };
};

// ASSETS
